import * as amplitude from '@amplitude/analytics-browser';

export class Amplitude {
  private static instance: Amplitude;

  private constructor(userID: string) {
    Amplitude.instance = amplitude;
    const useProductAnalytics = !!process.env.REACT_APP_AMPLITUDE_API_KEY;

    amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY ?? '', { defaultTracking: false });

    const deviceID = this.getDeviceId();
    if (deviceID && useProductAnalytics) amplitude.setDeviceId(deviceID);

    if (useProductAnalytics) amplitude.setUserId(userID);
  }

  public static getInstance(userID: string): Amplitude {
    if (!Amplitude.instance) {
      Amplitude.instance = new Amplitude(userID);
    }
    return Amplitude.instance;
  }

  public track(eventInput: string | amplitude.Types.BaseEvent, eventProperties?: Record<string, string | number> | undefined): void {
    amplitude.track(eventInput, eventProperties);
  }

  public getDeviceId(): string | undefined {
    return amplitude.getDeviceId();
  }
}